import React from 'react';
import './index.css';

const TermsPage = () => {
    return (
        <div className="policy-page-container">
            <h1>📜 TERMS & CONDITIONS — NOTTSIFY</h1>
            <p><strong>Last Updated:</strong> {new Date().toISOString().split('T')[0]}</p>

            <h2>1. Introduction</h2>
            <p>Welcome to NOTTSIFY. By accessing or using our website and services, you agree to comply with these Terms and Conditions.</p>
            <p>NOTTSIFY provides AI-powered study notes generation using user inputs and uploaded documents.</p>

            <h2>2. Eligibility</h2>
            <ul>
                <li>Users must be at least 13 years old.</li>
                <li>Users agree to provide accurate registration details.</li>
            </ul>

            <h2>3. Services Provided</h2>
            <p>NOTTSIFY provides:</p>
            <ul>
                <li>AI-generated study notes</li>
                <li>Notes generation from uploaded PDFs / files</li>
                <li>Credit-based usage system</li>
                <li>Subscription-based premium access</li>
            </ul>
            <h2>Service Availability</h2>
            <p>
                We do not guarantee uninterrupted service. Maintenance, third-party failures, or technical issues may affect availability.
            </p>

            <h2>4. Free Credit Usage</h2>
            <ul>
                <li>Every registered user receives 4 free credits daily.</li>
                <li>Credits may reset every 24 hours.</li>
                <li>Credits have no monetary value.</li>
                <li>Credits cannot be transferred or sold.</li>
            </ul>

            <h2>5. Subscription & Payments</h2>
            <ul>
                <li>Paid subscriptions are billed monthly or yearly.</li>
                <li>Payments are processed securely via Razorpay.</li>
                <li>We reserve the right to modify pricing at any time. Changes will not affect active billing cycles.</li>
            </ul>
            <p>Payments are processed securely through Razorpay. NOTTSIFY does not store card or banking details.</p>

            <h2>6. Refund Policy</h2>
            <ul>
                <li>No refunds once credits or services are used.</li>
                <li>Technical failure cases may be reviewed manually.</li>
            </ul>

            <h2>7. User Content & File Uploads</h2>
            <p>Users may upload files (PDF, documents, etc).</p>
            <p>By uploading files, users confirm:</p>
            <ul>
                <li>They own the content OR</li>
                <li>They have permission to upload it</li>
            </ul>
            <p>
                By uploading files, you consent to processing of content through third-party AI services for generating study notes.
            </p>
            <p>NOTTSIFY does not claim ownership of user files.</p>
            <p>Files may be processed by third-party AI APIs.</p>

            <h2>8. AI Generated Content Disclaimer</h2>
            <ul>
                <li>Content is AI generated.</li>
                <li>May contain inaccuracies.</li>
                <li>Must be verified before academic or professional use.</li>
                <li>NOTTSIFY is not responsible for exam results or academic performance.</li>
            </ul>

            <h2>9. Prohibited Usage</h2>
            <p>Users must NOT:</p>
            <ul>
                <li>Upload illegal content</li>
                <li>Upload copyrighted material without rights</li>
                <li>Try to hack or abuse credit system</li>
                <li>Reverse engineer the system</li>
                <li>Automated or bot credit generation is prohibited.</li>
            </ul>

            <h2>10. Account Suspension</h2>
            <p>We may suspend accounts for:</p>
            <ul>
                <li>Fraud</li>
                <li>Abuse</li>
                <li>Policy violations</li>
            </ul>

            <h2>11. Limitation of Liability</h2>
            <p>NOTTSIFY is not liable for:</p>
            <ul>
                <li>Academic losses</li>
                <li>Data loss due to external failures</li>
                <li>Third-party service downtime</li>
            </ul>

            <h2>Intellectual Property</h2>
            <p>
                All website content, branding, design, and software belong to NOTTSIFY and are protected by intellectual property laws.
            </p>

            <h2>12. Governing Law</h2>
            <p>These terms are governed by the laws of India.</p>

            <h2>13. Contact Information</h2>
            <p>
                If you have questions about these Terms, contact us at:
            </p>
            <ul>
                <li>Email: support@nottsify.com</li>
                <li>Business Owner: Dharuneshwar</li>
                <li>Country: India</li>
            </ul>
        </div>
    );
};

export default TermsPage;
